import React from "react";
import './EmptyView.css'

export default function EmptyView() {
    return (
      <div className={'root'}>
          <h4>No Data</h4>
      </div>
    );
}
